import React, { useMemo } from "react";
import Select from "react-select";
import { FormGroup, Label } from "reactstrap";

const ItemSelector = ({
  allItems,
  itemsLoading,
  currentItem,
  currentVariant,
  setCurrentItem,
  setCurrentVariant,
  onAddItem,
}) => {
  const itemOptions = useMemo(
    () =>
      allItems?.map(({ id, name, images, variants }) => ({
        value: id,
        label: name,
        image: images?.[0],
        variants,
      })) || [],
    [allItems]
  );

  const variantOptions = useMemo(
    () =>
      currentItem?.variants?.map(({ size }) => ({
        value: size,
        label: size,
      })) || [],
    [currentItem]
  );

  return (
    <>
      <FormGroup>
        <Label>Select Item</Label>
        <Select
          value={currentItem}
          options={itemOptions}
          onChange={(val) => {
            setCurrentItem(val);
            setCurrentVariant(null);
          }}
          isLoading={itemsLoading}
          isDisabled={itemsLoading}
          placeholder="Choose item..."
        />
      </FormGroup>

      {currentItem && (
        <FormGroup>
          <Label>Variant</Label>
          <Select
            value={currentVariant}
            options={variantOptions}
            onChange={setCurrentVariant}
            placeholder="Choose variant..."
          />
        </FormGroup>
      )}
    </>
  );
};

export default ItemSelector;
